import { render } from "./AuthPage.vue?vue&type=template&id=25d5072a"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"

import "./AuthPage.vue?vue&type=style&index=0&id=25d5072a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__